import { func, node, number, object, string } from 'prop-types'
import { Component, Children, Fragment } from 'react'
import { kuiperClassNames } from '@opallabs/kuiper'
import { getThemeStyles, getBackgroundStyles } from '../Helpers/themeHelper'
import SlideHeader from './slideHeader'

import './styles.scss'

export const themeExists = (theme) => Object.keys(theme).length > 0

const hasBackground = (theme, backgroundImageURL) =>
  backgroundImageURL || (theme && theme.background_image)
const DEFAULT_BACKGROUND_COLOR = '#222324' // $dark-surface-nd100

class Slide extends Component {
  static propTypes = {
    backgroundImageURL: string,
    children: node,
    customClassName: string,
    getSlide: func,
    presentationId: number,
    slideId: number,
    theme: object,
  }

  static defaultProps = {
    theme: {},
  }

  constructor(props) {
    super(props)
    this.state = {}
    if (props.getSlide) {
      props.getSlide(this.props.presentationId, this.props.slideId)
    }
  }

  get children() {
    return Children.map(this.props.children, (child, index) => {
      if (!child) return null
      return (
        <section key={index} className={kuiperClassNames('slide-child')}>
          {child}
        </section>
      )
    })
  }

  get backgroundColor() {
    const styles = getThemeStyles(this.props.theme, ['backgroundColor'])
    if (!styles.backgroundColor)
      styles.backgroundColor = DEFAULT_BACKGROUND_COLOR

    return styles
  }

  get backgroundStyles() {
    return getBackgroundStyles(this.props.theme, {
      backgroundImage: this.props.backgroundImageURL,
    })
  }

  render() {
    return (
      <div className={kuiperClassNames('slide', this.props.customClassName)}>
        {hasBackground(this.props.theme, this.props.backgroundImageURL) && (
          <div
            className={kuiperClassNames('background-image-wrapper')}
            style={this.backgroundStyles}
          />
        )}
        <div
          className={kuiperClassNames('background-color-wrapper')}
          style={this.backgroundColor}
        />
        {themeExists(this.props.theme) && (
          <Fragment>
            <SlideHeader theme={this.props.theme} />
          </Fragment>
        )}
        <div
          className={kuiperClassNames('slide-contents', {
            unthemed: !themeExists(this.props.theme),
          })}
        >
          {this.children}
        </div>
      </div>
    )
  }
}

export default Slide
